import React from 'react';

import type { ChangeEventHandler } from 'react';

interface ToggleSwitchProps {
  checked: boolean;
  disabled: boolean;
  handleToggle?: ChangeEventHandler<HTMLInputElement>;
  ariaLabel: string;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  disabled,
  handleToggle,
  ariaLabel,
}) => {
  return (
    <label className="toggle-switch" aria-label={ariaLabel}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleToggle}
        disabled={disabled}
      />
      <span className="toggle-switch-slider"></span>
    </label>
  );
};
